<template>
  <div>
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Afficher</label>
          <v-select
            v-model="perPage"
            :dir="'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @input="fetchMessages(true)"
          />
          <label>entrées</label>
        </b-col>
        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form @submit.prevent="fetchMessages(true)">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Rechercher..."
              />
              <b-button
                type="submit"
                variant="primary"
              >
                <span class="text-nowrap">Chercher</span>
              </b-button>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </div>
    <b-table
      ref="refMessageListTable"
      class="position-relative"
      :items="messages"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      empty-text="Aucun résultat trouvé"
      :sort-desc.sync="isSortDirDesc"
      :no-local-sorting="true"
      :busy="loading"
      @sort-changed="sortMessages($event)"
    >
      <!-- busy -->
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner label="Loading..." />
        </div>
      </template>

      <template #cell(user)="data">
        <b-link :to="{name:'users-view', params:{id:data.value.uuid}}">
          {{ data.value.name }}
        </b-link>
      </template>

      <!-- Column: created_at -->
      <template #cell(created_at)="data">
        <span>{{ moment(data.value).format("LLL") }}</span>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <div class="text-nowrap">
          <template v-if="!data.item.deleted_at">
            <feather-icon
              :id="`message-row-${data.item.uuid}-delete-icon`"
              v-b-modal="`modal-delete-message-${data.item.uuid}`"
              icon="TrashIcon"
              class="cursor-pointer"
              size="16"
            />
            <b-tooltip
              title="Supprimer"
              class="cursor-pointer"
              :target="`message-row-${data.item.uuid}-delete-icon`"
            />
            <b-modal
              :id="`modal-delete-message-${data.item.uuid}`"
              :ref="`modal-delete-message-${data.item.uuid}`"
              ok-variant="danger"
              ok-title="Supprimer"
              modal-class="modal-danger"
              centered
              title="Suppression du message"
            >
              <b-card-text>
                Souhaitez vous vraiment supprimer ce message ?
                <p class="text-danger font-weight-bold">
                  (Cette action est réversible)
                </p>
              </b-card-text>
              <template #modal-footer>
                <b-button
                  variant="secondary"
                  @click="hideModal(`modal-delete-message-${data.item.uuid}`)"
                >
                  annuler
                </b-button>
                <b-button
                  variant="danger"
                  :disabled="actionLoading"
                  @click="deleteMessage(data.item.uuid)"
                >
                  <b-spinner
                    v-show="actionLoading"
                    small
                  />
                  supprimer
                </b-button>
              </template>
            </b-modal>
          </template>
          <template v-if="data.item.deleted_at">
            <feather-icon
              :id="`message-row-${data.item.uuid}-restore-icon`"
              v-b-modal="`modal-restore-message-${data.item.uuid}`"
              icon="RotateCcwIcon"
              class="cursor-pointer mr-1"
              size="16"
            />
            <b-tooltip
              title="Restaurer"
              class="cursor-pointer"
              :target="`message-row-${data.item.uuid}-restore-icon`"
            />
            <b-modal
              :id="`modal-restore-message-${data.item.uuid}`"
              :ref="`modal-restore-message-${data.item.uuid}`"
              ok-variant="danger"
              ok-title="Supprimer"
              modal-class="modal-danger"
              centered
              title="Restauration du message"
            >
              <b-card-text>
                Souhaitez-vous vraiment restaurer ce message ?
              </b-card-text>
              <template #modal-footer>
                <b-button
                  variant="secondary"
                  @click="hideModal(`modal-restore-message-${data.item.uuid}`)"
                >
                  annuler
                </b-button>
                <b-button
                  variant="success"
                  :disabled="actionLoading"
                  @click="restoreMessage(data.item.uuid)"
                >
                  <b-spinner
                    v-show="actionLoading"
                    small
                  />
                  restaurer
                </b-button>
              </template>
            </b-modal>

            <!-- force delete -->
            <feather-icon
              :id="`message-row-${data.item.uuid}-force-delete-icon`"
              v-b-modal="`modal-force-delete-message-${data.item.uuid}`"
              icon="TrashIcon"
              class="cursor-pointer"
              size="16"
            />
            <b-tooltip
              title="Supprimer définitivement"
              class="cursor-pointer"
              :target="`message-row-${data.item.uuid}-force-delete-icon`"
            />
            <b-modal
              :id="`modal-force-delete-message-${data.item.uuid}`"
              :ref="`modal-force-delete-message-${data.item.uuid}`"
              ok-variant="danger"
              ok-title="Supprimer"
              modal-class="modal-danger"
              centered
              title="Suppression définitive du message"
            >
              <b-card-text>
                Souhaitez-vous vraiment supprimer définitivement ce  message ?<br>
                <p class="text-danger font-weight-bold">
                  (CETTE ACTION EST IRRÉVERSIBLE)
                </p>
              </b-card-text>
              <template #modal-footer>
                <b-button
                  variant="secondary"
                  @click="hideModal(`modal-force-delete-message-${data.item.uuid}`)"
                >
                  annuler
                </b-button>
                <b-button
                  variant="danger"
                  :disabled="actionLoading"
                  @click="forceDeleteMessage(data.item.uuid)"
                >
                  <b-spinner
                    v-show="actionLoading"
                    small
                  />
                  supprimer
                </b-button>
              </template>
            </b-modal>
          </template>
        </div>
      </template>
    </b-table>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span
            class="text-muted"
          >Affichage de {{ dataMeta.from }} à {{ dataMeta.to }} sur
            {{ dataMeta.total }} entrées</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalMessages"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            @change="changePage($event)"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BButton, BCardText,
  BCol,
  BForm,
  BFormInput, BLink, BModal, BPagination,
  BRow, BSpinner,
  BTable, BTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import axiosIns from '@/libs/axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'MessagesList',
  components: {
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BSpinner,
    BForm,
    vSelect,
    BModal,
    BCardText,
    BTooltip,
    BLink,
  },
  props: {
    platformFilter: {
      type: [String, null],
      default: null,
    },
    trashedFilter: {
      type: [Boolean, null],
      default: null,
    },
    apiUrl: {
      type: String,
      required: true,
    },
    tableColumns: {
      type: [Array, null],
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      actionLoading: false,
      perPageOptions: [5, 25, 50, 100],
      perPage: 25,
      searchQuery: '',
      sortBy: 'created_at',
      isSortDirDesc: true,
      messages: [],
      currentPage: 1,
      totalMessages: 0,
      dataMeta: {
        from: 0,
        to: 0,
        of: 0,
        total: 0,
      },
    }
  },
  watch: {
    trashedFilter: {
      handler() {
        this.fetchMessages(true)
      },
    },
    platformFilter: {
      handler() {
        this.fetchMessages(true)
      },
    },
  },
  mounted() {
    this.fetchMessages()
  },
  methods: {
    async fetchMessages(clearPagination = false) {
      try {
        this.loading = true
        const { data } = await axiosIns.get(this.apiUrl, {
          params: {
            onlyTrashed: this.trashedFilter,
            term: this.searchQuery,
            page: clearPagination ? 1 : this.currentPage,
            perPage: this.perPage,
            sortBy: this.sortBy,
            sortDirection: this.isSortDirDesc ? 'desc' : 'asc',
            platform_id: this.platformFilter,
          },
        })
        this.messages = data.data
        this.dataMeta.from = data.meta.from
        this.dataMeta.to = data.meta.to
        this.dataMeta.total = data.meta.total
        this.totalMessages = data.meta.total
        this.loading = false
      } catch (err) {
        this.loading = false
        this.$toast(
          {
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Erreur',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              text: `Une erreur s'est produite. erreur: ${err}`,
            },
          },
          { timeout: 5000 },
        )
      }
    },
    async deleteMessage(uuid) {
      try {
        this.actionLoading = true
        await axiosIns.delete(`messages/${uuid}`)
        this.$toast(
          {
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Enregistré !',
              icon: 'CheckCircleIcon',
              variant: 'success',
              text: 'Le message a été supprimé',
            },
          },
          { timeout: 5000 },
        )
        this.actionLoading = false
        this.hideModal(`modal-delete-message-${uuid}`)
        this.fetchMessages()
      } catch (err) {
        this.$toast(
          {
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Erreur',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              text: `Une erreur s'est produite. erreur: ${err}`,
            },
          },
          { timeout: 5000 },
        )
        this.actionLoading = false
      }
    },
    async restoreMessage(uuid) {
      try {
        this.actionLoading = true
        await axiosIns.post(`messages/${uuid}/restore`)
        this.$toast(
          {
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Enregistré !',
              icon: 'CheckCircleIcon',
              variant: 'success',
              text: 'Le message a été restauré',
            },
          },
          { timeout: 5000 },
        )
        this.actionLoading = false
        this.hideModal(`modal-restore-message-${uuid}`)
        this.fetchMessages()
      } catch (err) {
        this.$toast(
          {
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Erreur',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              text: `Une erreur s'est produite. erreur: ${err}`,
            },
          },
          { timeout: 5000 },
        )
        this.actionLoading = false
      }
    },
    async forceDeleteMessage(uuid) {
      try {
        this.actionLoading = true
        await axiosIns.delete(`messages/${uuid}/forceDelete`)
        this.$toast(
          {
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Enregistré !',
              icon: 'CheckCircleIcon',
              variant: 'success',
              text: 'Le message a été définitivement supprimé',
            },
          },
          { timeout: 5000 },
        )
        this.actionLoading = false
        this.hideModal(`modal-force-delete-message-${uuid}`)
        this.fetchMessages()
      } catch (err) {
        this.$toast(
          {
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Erreur',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              text: `Une erreur s'est produite. erreur: ${err}`,
            },
          },
          { timeout: 5000 },
        )
        this.actionLoading = false
      }
    },
    sortMessages(e) {
      this.isSortDirDesc = e.sortDesc
      this.sortBy = e.sortBy
      this.fetchMessages()
    },
    changePage(e) {
      this.currentPage = e
      this.fetchMessages()
    },
    hideModal(ref) {
      this.$refs[ref].hide()
    },
  },
}
</script>

<style lang="scss">
.per-page-selector {
  width: 90px;
}
@import '@core/scss/vue/libs/vue-select.scss';
</style>
